<form [formGroup]="formGroup" class="d-flex flex-wrap align-items-end gap-3" (ngSubmit)="submit()">
  <label class="filter-field d-flex flex-column gap-1" for="user-search">
    <span class="av-meta">{{ 'backoffice.users.filters.search' | translate }}</span>
    <input
      id="user-search"
      type="search"
      class="av-field"
      formControlName="search"
      autocomplete="off"
      [placeholder]="'backoffice.users.filters.search_placeholder' | translate"
    />
  </label>

  <label class="filter-field d-flex flex-column gap-1" for="user-status">
    <span class="av-meta">{{ 'backoffice.users.filters.app_status' | translate }}</span>
    <select id="user-status" class="av-field" formControlName="app_status">
      <option value="">{{ 'backoffice.users.filters.any_status' | translate }}</option>
      @for (status of statusOptions; track status) {
        <option [value]="status">{{ statusLabelKeys[status] | translate }}</option>
      }
    </select>
  </label>

  <div class="d-flex align-items-center gap-2">
    <button type="submit" class="av-btn av-btn-primary" [disabled]="disabled()">
      <mat-icon aria-hidden="true">filter_alt</mat-icon>
      {{ 'backoffice.common.actions.apply' | translate }}
    </button>

    <button type="button" class="av-btn" [disabled]="disabled()" (click)="reset()">
      <mat-icon aria-hidden="true">filter_alt_off</mat-icon>
      {{ 'backoffice.common.actions.clear' | translate }}
    </button>
  </div>
</form>
